import type { Qualification } from '../types';

export const qualifications: Qualification[] = [
  {
    id: 'baq',
    name: 'Basic Assistant Qualification',
    shortName: 'BAQ',
    description: 'Foundational qualification for all technicians',
    prerequisites: [],
    optional: false,
    order: 1,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'Discuss actions prohibited for Basic Assistants that require qualifications',
        description: 'Understanding the scope and limitations of Basic Assistant role',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Discuss documentation and photo requirements',
        description: 'Standards for jobsite documentation and photography',
        hasRubric: false,
      },
      {
        id: 'disc_3',
        category: 'discussion',
        title: 'Discuss standard tools and their uses',
        description: 'Overview of tools used in basic assistant work',
        hasRubric: false,
      },
      {
        id: 'disc_4',
        category: 'discussion',
        title: 'Discuss Morning Shop procedures',
        description: 'Daily morning shop preparation and checks',
        hasRubric: false,
      },
      {
        id: 'disc_5',
        category: 'discussion',
        title: 'Discuss Jobsite Setup & Wrapup',
        description: 'Proper jobsite preparation and cleanup procedures',
        hasRubric: false,
      },
      {
        id: 'disc_6',
        category: 'discussion',
        title: 'Discuss End-of-day Truck procedures',
        description: 'End-of-day vehicle shutdown and securing procedures',
        hasRubric: false,
      },
      {
        id: 'disc_7',
        category: 'discussion',
        title: 'Discuss Weekly Truck Inspections',
        description: 'Weekly vehicle maintenance and inspection procedures',
        hasRubric: false,
      },
      {
        id: 'disc_8',
        category: 'discussion',
        title: 'Discuss Monthly Inventory',
        description: 'Monthly inventory and stock management procedures',
        hasRubric: false,
      },
      {
        id: 'demo_1',
        category: 'demonstration',
        title: 'Demonstrate good jobsite photographic documentation',
        description: 'Hands-on demonstration of proper photo techniques',
        hasRubric: false,
      },
      {
        id: 'demo_2',
        category: 'demonstration',
        title: 'Demonstrate proper tool care and accountability',
        description: 'Tool maintenance and tracking procedures',
        hasRubric: false,
      },
      {
        id: 'demo_3',
        category: 'demonstration',
        title: 'Demonstrate completion of the Morning Shop procedures',
        description: 'Hands-on demonstration of morning prep',
        hasRubric: false,
      },
      {
        id: 'demo_4',
        category: 'demonstration',
        title: 'Demonstrate Jobsite Setup & Wrapup procedures',
        description: 'Hands-on jobsite preparation and cleanup',
        hasRubric: false,
      },
      {
        id: 'demo_5',
        category: 'demonstration',
        title: 'Demonstrate completion of the End-of-Day Truck Shutdown procedures',
        description: 'Hands-on vehicle shutdown demonstration',
        hasRubric: false,
      },
      {
        id: 'ride_1',
        category: 'ridealong',
        title: 'Support a Technician in completing a repair',
        description: 'Field ridealong supporting technician on repair job',
        hasRubric: true,
      },
    ],
  },
  {
    id: 'electrical',
    name: 'Electrical Safety Qualification',
    shortName: 'Electrical',
    description: 'Electrical safety and competency for pump technicians',
    prerequisites: ['baq'],
    optional: false,
    order: 2,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'Discuss safe management of electrical circuits on a jobsite',
        description: 'Safe electrical practices in field environments',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Describe Lockout / Tagout (LOTO) procedures',
        description: 'LOTO safety protocols and implementation',
        hasRubric: false,
      },
      {
        id: 'disc_3',
        category: 'discussion',
        title: 'Electrical hazard recognition',
        description: 'Identifying electrical hazards on the job',
        hasRubric: false,
      },
      {
        id: 'disc_4',
        category: 'discussion',
        title: 'Describe voltage, amperage, and electrical phases',
        description: 'Electrical fundamentals and concepts',
        hasRubric: false,
      },
      {
        id: 'disc_5',
        category: 'discussion',
        title: 'Describe wire sizing and voltage drop',
        description: 'Wire specifications and calculations',
        hasRubric: false,
      },
      {
        id: 'disc_6',
        category: 'discussion',
        title: 'Describe grounding and bonding requirements',
        description: 'Proper grounding and bonding procedures',
        hasRubric: false,
      },
      {
        id: 'disc_7',
        category: 'discussion',
        title: 'Describe pressure switch wiring and adjustment',
        description: 'Pressure switch installation and tuning',
        hasRubric: false,
      },
      {
        id: 'disc_8',
        category: 'discussion',
        title: 'Describe conduit and junction box requirements',
        description: 'Proper conduit and box installation standards',
        hasRubric: false,
      },
      {
        id: 'disc_9',
        category: 'discussion',
        title: 'Describe the proper use of a multimeter in all modes',
        description: 'Multimeter operation and functionality',
        hasRubric: false,
      },
      {
        id: 'disc_10',
        category: 'discussion',
        title: 'Describe insulation resistance (megger) testing',
        description: 'Megger testing procedures and interpretation',
        hasRubric: false,
      },
      {
        id: 'disc_11',
        category: 'discussion',
        title: 'Describe proper wire splicing and terminations',
        description: 'Wire joining and termination methods',
        hasRubric: false,
      },
      {
        id: 'disc_12',
        category: 'discussion',
        title: 'Describe correct grounding at the wellhead',
        description: 'Wellhead grounding requirements',
        hasRubric: false,
      },
      {
        id: 'disc_13',
        category: 'discussion',
        title: 'Describe safe reconnection and system energization',
        description: 'Safe procedures for reconnecting and powering systems',
        hasRubric: false,
      },
      {
        id: 'disc_14',
        category: 'discussion',
        title: 'Describe unsafe or non-compliant electrical conditions',
        description: 'Recognition of improper electrical installations',
        hasRubric: false,
      },
      {
        id: 'demo_1',
        category: 'demonstration',
        title: 'Safely and correctly LOTO a breaker for HV repair',
        description: 'Hands-on LOTO demonstration on high voltage equipment',
        hasRubric: false,
      },
      {
        id: 'demo_2',
        category: 'demonstration',
        title: 'Correctly demonstrate use of each multimeter function on a live circuit',
        description: 'Multimeter operation in field conditions',
        hasRubric: false,
      },
      {
        id: 'demo_3',
        category: 'demonstration',
        title: 'Correctly calculate proper wire sizing and voltage drop for a pump application',
        description: 'Wire sizing calculations for pump installations',
        hasRubric: false,
      },
      {
        id: 'demo_4',
        category: 'demonstration',
        title: 'Grounding and bonding requirements',
        description: 'Hands-on grounding and bonding installation',
        hasRubric: false,
      },
      {
        id: 'demo_5',
        category: 'demonstration',
        title: 'Pressure switch wiring and adjustment',
        description: 'Hands-on pressure switch installation',
        hasRubric: false,
      },
      {
        id: 'demo_6',
        category: 'demonstration',
        title: 'Conduit and junction box requirements',
        description: 'Proper conduit and box installation',
        hasRubric: false,
      },
      {
        id: 'demo_7',
        category: 'demonstration',
        title: 'Verifying power is de-energized prior to work',
        description: 'Safety verification procedures',
        hasRubric: false,
      },
      {
        id: 'demo_8',
        category: 'demonstration',
        title: 'Proper use of a multimeter',
        description: 'Multimeter operation demonstration',
        hasRubric: false,
      },
      {
        id: 'demo_9',
        category: 'demonstration',
        title: 'Performing insulation resistance (megger) testing',
        description: 'Hands-on megger testing',
        hasRubric: false,
      },
      {
        id: 'demo_10',
        category: 'demonstration',
        title: 'Proper wire splicing and terminations',
        description: 'Hands-on wire termination techniques',
        hasRubric: false,
      },
      {
        id: 'demo_11',
        category: 'demonstration',
        title: 'Correct grounding at the wellhead',
        description: 'Wellhead grounding installation',
        hasRubric: false,
      },
      {
        id: 'demo_12',
        category: 'demonstration',
        title: 'Safe reconnection and system energization',
        description: 'Safe reconnection procedures',
        hasRubric: false,
      },
      {
        id: 'demo_13',
        category: 'demonstration',
        title: 'Identification of unsafe or non-compliant electrical conditions',
        description: 'Recognizing improper installations',
        hasRubric: false,
      },
    ],
  },
  {
    id: 'hoist',
    name: 'Hoist Operator Qualification',
    shortName: 'Hoist Operator',
    description: 'Certification to operate field service hoists and lifting equipment',
    prerequisites: ['baq', 'electrical'],
    optional: false,
    order: 3,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'PPE / First Aid',
        description: 'Personal protective equipment and first aid procedures',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Hoist Safe Capacity',
        description: 'Understanding hoist weight limits and load calculations',
        hasRubric: false,
      },
      {
        id: 'disc_3',
        category: 'discussion',
        title: 'Hoist Safe Positioning',
        description: 'Proper positioning and stabilization of hoists',
        hasRubric: false,
      },
      {
        id: 'disc_4',
        category: 'discussion',
        title: 'Overhead Hazard Awareness',
        description: 'Recognizing and avoiding overhead hazards',
        hasRubric: false,
      },
      {
        id: 'disc_5',
        category: 'discussion',
        title: 'Calculating String Weight',
        description: 'Weight calculations for pump string assemblies',
        hasRubric: false,
      },
      {
        id: 'disc_6',
        category: 'discussion',
        title: 'Startup Pre-checks',
        description: 'Pre-operation inspection and safety checks',
        hasRubric: false,
      },
      {
        id: 'disc_7',
        category: 'discussion',
        title: 'Hydraulic System and PTO',
        description: 'Hydraulic systems and power take-off operation',
        hasRubric: false,
      },
      {
        id: 'disc_8',
        category: 'discussion',
        title: 'Documentation Standards',
        description: 'Recording and documentation procedures',
        hasRubric: false,
      },
      {
        id: 'disc_9',
        category: 'discussion',
        title: 'Fleet Configurations',
        description: 'Different hoist vehicle configurations and capabilities',
        hasRubric: false,
      },
      {
        id: 'disc_10',
        category: 'discussion',
        title: 'Rigging Fundamentals — slings, shackles, sheaves, hooks, etc',
        description: 'Proper rigging equipment and techniques',
        hasRubric: false,
      },
      {
        id: 'disc_11',
        category: 'discussion',
        title: 'Hand signal communication',
        description: 'Standard hand signals for hoist operations',
        hasRubric: false,
      },
      {
        id: 'disc_12',
        category: 'discussion',
        title: 'Emergency stop procedures',
        description: 'Emergency procedures and equipment shutdown',
        hasRubric: false,
      },
      {
        id: 'disc_13',
        category: 'discussion',
        title: 'Shutdown and Securing Equipment for Movement',
        description: 'Equipment securing for transport',
        hasRubric: false,
      },
      {
        id: 'demo_1',
        category: 'demonstration',
        title: 'Rig-up Precheck',
        description: 'Demonstration of pre-operation checklist',
        hasRubric: false,
      },
      {
        id: 'demo_2',
        category: 'demonstration',
        title: 'Raise the boom',
        description: 'Proper boom raising procedure',
        hasRubric: false,
      },
      {
        id: 'demo_3',
        category: 'demonstration',
        title: 'Stow the boom',
        description: 'Proper boom lowering and stowing',
        hasRubric: false,
      },
      {
        id: 'demo_4',
        category: 'demonstration',
        title: 'Controlled lifting and lowering of loads',
        description: 'Safe load handling operations',
        hasRubric: false,
      },
      {
        id: 'demo_5',
        category: 'demonstration',
        title: 'Safe pump removal and installation',
        description: 'Hands-on pump handling procedure',
        hasRubric: false,
      },
      {
        id: 'ride_1',
        category: 'ridealong',
        title: 'Pump job Ridealong',
        description: 'Field experience on pump service jobs',
        hasRubric: true,
      },
      {
        id: 'ride_2',
        category: 'ridealong',
        title: 'Brushing/Baling Ridealong',
        description: 'Field experience with well brushing and baling',
        hasRubric: true,
      },
      {
        id: 'ride_3',
        category: 'ridealong',
        title: 'Rehab Ridealong',
        description: 'Field experience with well rehabilitation work',
        hasRubric: true,
      },
      {
        id: 'ride_4',
        category: 'ridealong',
        title: 'Check Ride (requires Pump Replacement + Brushing/Baling or Rehab first)',
        description: 'Final evaluation ride - requires prior ridealong completions',
        hasRubric: true,
      },
    ],
  },
  {
    id: 'bighoss',
    name: 'Big Hoss Endorsement',
    shortName: 'Big Hoss',
    description: 'Advanced hoist operation and larger equipment endorsement',
    prerequisites: ['hoist'],
    optional: true,
    order: 4,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'PPE / First Aid',
        description: 'Personal protective equipment and first aid procedures',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Hoist Safe Capacity',
        description: 'Understanding Big Hoss weight limits and load calculations',
        hasRubric: false,
      },
      {
        id: 'disc_3',
        category: 'discussion',
        title: 'Hoist Safe Positioning',
        description: 'Proper positioning and stabilization for Big Hoss',
        hasRubric: false,
      },
      {
        id: 'disc_4',
        category: 'discussion',
        title: 'Overhead Hazard Awareness',
        description: 'Advanced overhead hazard recognition',
        hasRubric: false,
      },
      {
        id: 'disc_5',
        category: 'discussion',
        title: 'Calculating String Weight',
        description: 'Advanced weight calculations for large strings',
        hasRubric: false,
      },
      {
        id: 'disc_6',
        category: 'discussion',
        title: 'Startup Pre-checks',
        description: 'Big Hoss pre-operation inspection',
        hasRubric: false,
      },
      {
        id: 'disc_7',
        category: 'discussion',
        title: 'Hydraulic System and PTO',
        description: 'Advanced hydraulic systems operation',
        hasRubric: false,
      },
      {
        id: 'disc_8',
        category: 'discussion',
        title: 'Documentation Standards',
        description: 'Recording and documentation for Big Hoss operations',
        hasRubric: false,
      },
      {
        id: 'disc_9',
        category: 'discussion',
        title: 'Fleet Configurations',
        description: 'Big Hoss vehicle configurations',
        hasRubric: false,
      },
      {
        id: 'disc_10',
        category: 'discussion',
        title: 'Rigging Fundamentals — slings, shackles, sheaves, hooks, etc',
        description: 'Advanced rigging techniques and equipment',
        hasRubric: false,
      },
      {
        id: 'disc_11',
        category: 'discussion',
        title: 'Hand signal communication',
        description: 'Hand signals for Big Hoss operations',
        hasRubric: false,
      },
      {
        id: 'disc_12',
        category: 'discussion',
        title: 'Emergency stop procedures',
        description: 'Emergency procedures for Big Hoss',
        hasRubric: false,
      },
      {
        id: 'disc_13',
        category: 'discussion',
        title: 'Shutdown and Securing Equipment for Movement',
        description: 'Big Hoss equipment securing',
        hasRubric: false,
      },
      {
        id: 'disc_14',
        category: 'discussion',
        title: 'Cathead use and functionality',
        description: 'Cathead equipment operation and safety',
        hasRubric: false,
      },
      {
        id: 'disc_15',
        category: 'discussion',
        title: 'Cathead rope safety',
        description: 'Cathead rope handling and safety procedures',
        hasRubric: false,
      },
      {
        id: 'disc_16',
        category: 'discussion',
        title: 'Job safety hazards',
        description: 'Recognizing job-specific safety hazards',
        hasRubric: false,
      },
      {
        id: 'demo_1',
        category: 'demonstration',
        title: 'Rig-up Precheck',
        description: 'Big Hoss pre-operation checklist',
        hasRubric: false,
      },
      {
        id: 'demo_2',
        category: 'demonstration',
        title: 'Raise the boom',
        description: 'Big Hoss boom raising',
        hasRubric: false,
      },
      {
        id: 'demo_3',
        category: 'demonstration',
        title: 'Stow the boom',
        description: 'Big Hoss boom stowing',
        hasRubric: false,
      },
      {
        id: 'demo_4',
        category: 'demonstration',
        title: 'Controlled lifting and lowering of loads',
        description: 'Advanced load handling with Big Hoss',
        hasRubric: false,
      },
      {
        id: 'demo_5',
        category: 'demonstration',
        title: 'Safe pump removal and installation',
        description: 'Large pump handling with Big Hoss',
        hasRubric: false,
      },
      {
        id: 'demo_6',
        category: 'demonstration',
        title: 'String weight calculation',
        description: 'Hands-on weight calculation demonstration',
        hasRubric: false,
      },
      {
        id: 'demo_7',
        category: 'demonstration',
        title: 'Job safety awareness and call out',
        description: 'Safety communication and hazard awareness',
        hasRubric: false,
      },
      {
        id: 'demo_8',
        category: 'demonstration',
        title: 'Electrical Lock out and tag out',
        description: 'LOTO procedures with Big Hoss',
        hasRubric: false,
      },
      {
        id: 'ride_1',
        category: 'ridealong',
        title: 'Pump Pull',
        description: 'Field ride on pump pull operations',
        hasRubric: true,
      },
      {
        id: 'ride_2',
        category: 'ridealong',
        title: 'Pump Set',
        description: 'Field ride on pump installation',
        hasRubric: true,
      },
      {
        id: 'ride_3',
        category: 'ridealong',
        title: 'Well Brush and Bailing',
        description: 'Field ride on well brushing and bailing',
        hasRubric: true,
      },
      {
        id: 'ride_4',
        category: 'ridealong',
        title: 'Well Rehab',
        description: 'Field ride on well rehabilitation',
        hasRubric: true,
      },
    ],
  },
  {
    id: 'lead_install',
    name: 'Lead Install Tech',
    shortName: 'Lead Install',
    description: 'Leadership and technical expertise in pump installation operations',
    prerequisites: ['hoist'],
    optional: false,
    order: 5,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'Discuss well construction and completion standards (surface sealing, annular sealing, setbacks)',
        description: 'Surface and annular sealing methods (cement vs. bentonite), setback distances from septic systems and contamination sources, sleeve vs. pitless adapter completion, and commingling prevention per TAC 76.100',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Discuss TDLR pump installation regulations (76.108) and closed connection requirements',
        description: 'Maintaining groundwater integrity during pump repair/installation, closed connection requirements, disinfection for wells used for human consumption, and prohibition on oil/gas industry materials',
        hasRubric: false,
      },
      {
        id: 'disc_3',
        category: 'discussion',
        title: 'Discuss drop pipe sizing, material selection, and cable binding per TDLR',
        description: 'Drop pipe specifications, material selection criteria, and TDLR-compliant cable binding methods (tape vs. steel bands)',
        hasRubric: false,
      },
      {
        id: 'disc_4',
        category: 'discussion',
        title: 'Discuss check valve placement, sizing, and failure modes (backspin, upthrust, water hammer)',
        description: 'Check valve placement within 25 ft of pump, sizing per TDLR, positive sealing requirements, and consequences of missing or failed check valves',
        hasRubric: false,
      },
      {
        id: 'disc_5',
        category: 'discussion',
        title: 'Discuss well seal and bullhead assembly identification and selection',
        description: 'Types of well seals and bullhead assemblies, selection criteria based on casing size and application',
        hasRubric: false,
      },
      {
        id: 'disc_6',
        category: 'discussion',
        title: 'Discuss pressure tank and captive air tank sizing, installation, and plumbing',
        description: 'Sizing calculations, installation best practices, proper plumbing connections, and waterlogged tank detection (fast cycling, pressure drop during off-time)',
        hasRubric: false,
      },
      {
        id: 'disc_7',
        category: 'discussion',
        title: 'Discuss cycle stop valve installation, adjustment, and constant pressure systems',
        description: 'Cycle stop valve setup, adjustment procedures, and constant pressure system operation (SubDrive/MonoDrive with small pressure tank)',
        hasRubric: false,
      },
      {
        id: 'disc_8',
        category: 'discussion',
        title: 'Discuss control box and VFD identification, selection by application, and manufacturer specs',
        description: 'Single-phase motor control boxes (potential relays, QD solid-state, BIAC switches), three-phase panel requirements, contactor sizing, and overload settings',
        hasRubric: false,
      },
      {
        id: 'disc_9',
        category: 'discussion',
        title: 'Discuss single-phase vs. three-phase power characteristics and motor/pump sizing using TDH charts',
        description: 'Power phase characteristics, total dynamic head calculations, and pump/motor selection using manufacturer performance curves',
        hasRubric: false,
      },
      {
        id: 'disc_10',
        category: 'discussion',
        title: 'Discuss proper cable sizing and selection using cable sizing charts',
        description: 'Cable sizing methodology, manufacturer cable sizing charts, and considerations for voltage drop over distance',
        hasRubric: false,
      },
      {
        id: 'disc_11',
        category: 'discussion',
        title: 'Discuss splice theory, materials selection, and application',
        description: 'Splice types, material compatibility, waterproofing methods, and field application techniques',
        hasRubric: false,
      },
      {
        id: 'disc_12',
        category: 'discussion',
        title: 'Discuss well disinfection requirements and procedures',
        description: 'Disinfection requirements for wells used for human consumption, chlorination methods, contact time, and testing',
        hasRubric: false,
      },
      {
        id: 'disc_13',
        category: 'discussion',
        title: 'Discuss abandoned and deteriorated well responsibilities and reporting',
        description: 'Definition of abandoned/deteriorated wells per TAC 1901.255, notification obligations, plugging/capping standards, 180-day compliance window, and GCD enforcement',
        hasRubric: false,
      },
      {
        id: 'demo_1',
        category: 'demonstration',
        title: 'Diagnose a well inop, pull pump, and replace pump',
        description: 'End-to-end demonstration of diagnosing an inoperable well, pulling the existing pump, and installing a replacement',
        hasRubric: true,
      },
      {
        id: 'demo_2',
        category: 'demonstration',
        title: 'Assemble a 5 HP or larger pump/motor, make splice, and set pump with air line',
        description: 'Full assembly of a large pump/motor unit including splice, setting with air line for depth measurement',
        hasRubric: true,
      },
      {
        id: 'demo_3',
        category: 'demonstration',
        title: 'Install and properly set up a VFD',
        description: 'Variable frequency drive installation, programming, and verification of proper operation',
        hasRubric: true,
      },
      {
        id: 'demo_4',
        category: 'demonstration',
        title: 'Install pressure tank, pressure switch, and cycle stop valve',
        description: 'Complete pressure system installation including tank, switch wiring/adjustment, and cycle stop valve setup',
        hasRubric: true,
      },
      {
        id: 'demo_5',
        category: 'demonstration',
        title: 'Build an above-surface tank (AST) system and tie in well',
        description: 'AST system construction including plumbing, controls, and well connection',
        hasRubric: true,
      },
      {
        id: 'demo_6',
        category: 'demonstration',
        title: 'Demonstrate proper cable sizing calculation for a pump application',
        description: 'Using cable sizing charts and voltage drop calculations to select correct cable for a given installation',
        hasRubric: false,
      },
      {
        id: 'demo_7',
        category: 'demonstration',
        title: 'Demonstrate insulation resistance (megger) testing on a submersible motor',
        description: 'Proper megger testing procedure on a submersible motor with interpretation of results',
        hasRubric: false,
      },
      {
        id: 'demo_8',
        category: 'demonstration',
        title: 'Demonstrate proper check valve selection and installation',
        description: 'Selecting the correct check valve for the application and installing per TDLR requirements',
        hasRubric: false,
      },
      {
        id: 'ride_1',
        category: 'ridealong',
        title: 'Lead a pump replacement job',
        description: 'Act as lead technician on a pump replacement from diagnosis through startup, with a qualified lead observing',
        hasRubric: true,
      },
      {
        id: 'ride_2',
        category: 'ridealong',
        title: 'Lead an AST system installation',
        description: 'Act as lead technician on an above-surface tank system installation, with a qualified lead observing',
        hasRubric: true,
      },
    ],
  },
  {
    id: 'lead_diagnostic',
    name: 'Lead Diagnostic Tech',
    shortName: 'Lead Diagnostic',
    description: 'Leadership and technical expertise in pump diagnostics and troubleshooting',
    prerequisites: ['lead_install'],
    optional: false,
    order: 6,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'Discuss systematic troubleshooting methodology for inoperable wells',
        description: 'Structured approach to diagnosing well failures: power verification, control box checks, motor testing, pump performance analysis, and elimination process',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Discuss motor failure diagnosis — electrical vs. mechanical causes',
        description: 'Differentiating electrical failures (insulation breakdown, winding faults) from mechanical failures (seized bearings, sand lock), using megger and amp draw analysis',
        hasRubric: false,
      },
      {
        id: 'disc_3',
        category: 'discussion',
        title: 'Discuss pump performance analysis using TDH curves and field measurements',
        description: 'Comparing field flow/pressure measurements against manufacturer performance curves to identify pump wear, sizing issues, or well yield problems',
        hasRubric: false,
      },
      {
        id: 'disc_4',
        category: 'discussion',
        title: 'Discuss voltage and current unbalance diagnosis and acceptable thresholds',
        description: 'Measuring phase-to-phase voltage and current unbalance, 5% current unbalance max threshold, relationship between 0.8% voltage unbalance and >5% current unbalance',
        hasRubric: false,
      },
      {
        id: 'disc_5',
        category: 'discussion',
        title: 'Discuss groundwater chemistry fundamentals (EC, TDS, SAR, pH)',
        description: 'Specific electrical conductance, total dissolved solids, sodium adsorption ratio effects on soil/crops, carbonate and pH relationships, and importance of rapid sample analysis',
        hasRubric: false,
      },
      {
        id: 'disc_6',
        category: 'discussion',
        title: 'Discuss Texas aquifers — depths, formations, and water quality characteristics for the service area',
        description: 'Major and minor aquifers of Texas, formation characteristics, water quality by aquifer (TDS, arsenic, gross alpha), confined vs. unconfined, and groundwater conservation districts',
        hasRubric: false,
      },
      {
        id: 'disc_7',
        category: 'discussion',
        title: 'Discuss water quality testing — when to test, what to test for, and interpreting results',
        description: 'Sampling protocols, common analytes, interpreting lab reports, and determining whether issues are well-related vs. aquifer-related',
        hasRubric: false,
      },
      {
        id: 'disc_8',
        category: 'discussion',
        title: 'Discuss pressure system diagnosis — waterlogged tanks, cycle time analysis, pressure switch issues',
        description: 'Diagnosing waterlogged tanks (fast cycling, pressure drop), cycle time measurement, pressure switch calibration and failure modes, and constant pressure system troubleshooting',
        hasRubric: false,
      },
      {
        id: 'disc_9',
        category: 'discussion',
        title: 'Discuss well yield testing and drawdown analysis',
        description: 'Methods for measuring well yield, drawdown measurement, recovery rate analysis, and determining sustainable pumping rates',
        hasRubric: false,
      },
      {
        id: 'disc_10',
        category: 'discussion',
        title: 'Discuss TDLR reporting requirements for injurious water or constituents (76.71)',
        description: 'Reporting obligations when encountering injurious water, completion standards for wells encountering contamination per TAC 76.101/76.102',
        hasRubric: false,
      },
      {
        id: 'demo_1',
        category: 'demonstration',
        title: 'Diagnose and resolve a motor electrical failure using multimeter and megger',
        description: 'Systematic electrical diagnosis of a failed submersible motor using multimeter readings and insulation resistance testing',
        hasRubric: true,
      },
      {
        id: 'demo_2',
        category: 'demonstration',
        title: 'Perform a pump performance test and compare against manufacturer curves',
        description: 'Field measurement of flow rate, pressure, and amp draw compared against manufacturer TDH curves to assess pump condition',
        hasRubric: true,
      },
      {
        id: 'demo_3',
        category: 'demonstration',
        title: 'Diagnose and resolve a pressure system malfunction (tank, switch, or valve)',
        description: 'Troubleshooting a pressure system issue through systematic elimination — tank pre-charge check, switch testing, valve inspection',
        hasRubric: true,
      },
      {
        id: 'demo_4',
        category: 'demonstration',
        title: 'Perform cable identification when color code is unknown (single-phase 3-wire method)',
        description: 'Using the Franklin AIM method to identify cable conductors when original color coding is lost or unreadable',
        hasRubric: false,
      },
      {
        id: 'demo_5',
        category: 'demonstration',
        title: 'Calculate and verify voltage drop for an existing installation',
        description: 'Measuring actual voltage drop from panel to motor and comparing against calculated expected drop to identify cable issues',
        hasRubric: false,
      },
      {
        id: 'demo_6',
        category: 'demonstration',
        title: 'Diagnose a sandlocked/bound pump and recover',
        description: 'Identifying a sandlocked pump condition and executing recovery procedures without damaging the well or equipment',
        hasRubric: true,
      },
      {
        id: 'demo_7',
        category: 'demonstration',
        title: 'Perform a well yield / drawdown test and document results',
        description: 'Conducting a well yield test with drawdown measurements, documenting results, and calculating sustainable yield',
        hasRubric: true,
      },
      {
        id: 'ride_1',
        category: 'ridealong',
        title: 'Lead a diagnostic call on an inoperable well',
        description: 'Act as lead technician on a diagnostic service call for an inoperable well, with a qualified lead observing',
        hasRubric: true,
      },
      {
        id: 'ride_2',
        category: 'ridealong',
        title: 'Lead a water quality investigation and recommend corrective action',
        description: 'Act as lead technician on a water quality complaint call, performing testing and recommending corrective action, with a qualified lead observing',
        hasRubric: true,
      },
    ],
  },
  // ── Plumbing Skill Tree (test data) ──
  {
    id: 'plumb_apprentice',
    name: 'Apprentice Plumber',
    shortName: 'Apprentice',
    description: 'Foundational plumbing skills for new hires',
    prerequisites: [],
    optional: false,
    order: 1,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'Learn to dig',
        description: 'Trenching fundamentals and proper excavation techniques',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Learn to get tools',
        description: 'Tool identification, retrieval, and organization on the jobsite',
        hasRubric: false,
      },
    ],
  },
  {
    id: 'plumb_master',
    name: 'Master Plumber',
    shortName: 'Master',
    description: 'Advanced plumbing skills and leadership',
    prerequisites: ['plumb_apprentice'],
    optional: false,
    order: 2,
    items: [
      {
        id: 'disc_1',
        category: 'discussion',
        title: 'Learn to solder',
        description: 'Pipe soldering techniques for copper and brass fittings',
        hasRubric: false,
      },
      {
        id: 'disc_2',
        category: 'discussion',
        title: 'Learn to set a toilet',
        description: 'Toilet installation, wax ring sealing, and flange alignment',
        hasRubric: false,
      },
    ],
  },
];
